import { Checkbox, type CheckboxProps, type FormItemProps } from "antd";
import type { ReactNode } from "react";
import { FormItem } from "../FormItem";
import { StyledCheckboxContainer } from "./FormCheckbox.styles";

type Props<TForm> = FormItemProps<TForm> & {
  label?: ReactNode;

  /** `disabled` moved out of `checkboxProps` for convenience as it used frequently */
  disabled?: boolean;
  /** Antd `SelectProps` */
  checkboxProps?: Omit<CheckboxProps, "disabled">;
};

// TODO: implement showing Skeleton (with or without known skeleton)
export const FormCheckbox = <TForm = unknown>({ label, disabled, checkboxProps, ...rest }: Props<TForm>) => {
  const content = (
    <>
      <FormItem<TForm> label={label} colon={false} valuePropName="checked" {...rest}>
        <Checkbox disabled={disabled} {...checkboxProps} />
      </FormItem>
    </>
  );

  return rest.hidden ? content : <StyledCheckboxContainer>{content}</StyledCheckboxContainer>;
};
